import { Paragraph } from 'grommet'

export default Paragraph
